import React, { useState, useEffect, useContext } from 'react';
import CustomerFormModal from './CustomerFormModal.jsx';
import {Context} from './StockManagerContext.jsx';
import { canSeeCustomerDetails } from '../private/permissions.js';

export default function CustomerFormButton({ startVisible = false }) {
    const { currentCustomer, setOpenCustomerForm, currentUser } = useContext(Context);
    const [ openModal, setOpenModal ] = useState(_ => _);
    const [ buttonVisible, setVisible ] = useState(startVisible);

    useEffect(() => {
        if ( canSeeCustomerDetails(currentUser.userRole) ) {
            setVisible(true);
        }
    }, [currentUser]);

    return buttonVisible && (
        <>
            <a className={`btn ${currentCustomer ? 'btn-warning' : 'btn-light'} customer-form`} onClick={openModal} style={{ cursor: 'pointer' }}>
                <span className={currentCustomer ? "edit-contact" : "add-contact"}></span>
                {currentCustomer ? <span className="customer-name">{currentCustomer.Full_Name}</span> : ''}
            </a>
            <CustomerFormModal getMethods={methods => {
                setOpenModal(() => methods.open);
                setOpenCustomerForm(() => methods.open);
                console.log('CustomerForm', methods);
            }} />
        </>
    );
}
